<template>
  <div v-loading="isLoading" class="container">
    <div v-if="!showResult" class="approval">
      <div class="title">{{ title }}</div>
      <div class="form-container">
        <el-form ref="formRef" :model="formData" class="demo-form-inline" :rules="rules">
          <el-form-item prop="mobile">
            <div class="label">
              <span>手机号：</span>
            </div>
            <div class="row-phone">
              <a-input v-model="formData.mobile" placeholder="请输入手机号" />
              <a-button
                link
                class="getCodeText"
                :disabled="send"
                :loading="loading"
                @click="getCode"
                >{{ sendCodeText }}</a-button
              >
            </div>
          </el-form-item>
          <el-form-item prop="captcha">
            <div class="label">
              <span>验证码：</span>
            </div>
            <div>
              <a-input v-model="formData.captcha" placeholder="请输入验证码" />
            </div>
          </el-form-item>
          <el-form-item prop="content">
            <div class="label">
              <span>审批意见：</span>
            </div>
            <div>
              <a-input
                v-model="formData.content"
                type="textarea"
                :rows="4"
                placeholder="请输入审批意见"
              />
            </div>
          </el-form-item>
        </el-form>
        <div class="button-group">
          <a-button
            type="primary"
            :loading="confirmLoading"
            style="margin-right:36px;"
            @click="through"
            >通过</a-button
          >
          <a-button @click="rejected">驳回</a-button>
        </div>
      </div>
    </div>
    <div v-else class="approval-result">
      <div v-if="approvalResult === 'success'" class="approval-result__success"></div>
      <div v-else class="approval-result__fail"></div>
    </div>
  </div>
</template>

<script>
import { getSmsCode, approveUpdate, approveIsApprove } from "../api";

export default {
  name: "ApplyLoad",
  data() {
    return {
      title: "",
      sendCodeText: "获取验证码",
      formData: {
        mobile: "",
        captcha: "",
        content: "",
        uniqueFlag: "",
      },
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        captcha: [{ required: true, message: "请输入验证码", trigger: "change" }],
        content: [{ required: true, message: "请输入审批意见", trigger: "change" }],
      },
      loading: false,
      confirmLoading: false,
      send: false,
      isLoading: true,
      showResult: false, // 是否显示审批结果
      approvalResult: "success",
    };
  },
  async created() {
    // 根据路由获取模块名称
    const routeType = this.$route.query.type;
    this.title =
      // eslint-disable-next-line no-nested-ternary
      routeType === "applyLoad"
        ? "满载率不达标审批"
        : routeType === "planEdit"
        ? "计划单修改审批"
        : "费用差审批";

    this.addMeta();
    this.getApproveStatus();
  },
  methods: {
    // 获取审批状态
    async getApproveStatus() {
      try {
        const params = { uniqueFlag: this.$route.query.uuid };
        const res = await approveIsApprove(params);
        // 1:待审批 2:同意 3:驳回
        if (res === 1) {
          this.showResult = false;
        } else if (res === 2) {
          this.showResult = true;
          this.approvalResult = "success";
        } else if (res === 3) {
          this.showResult = true;
          this.approvalResult = "fail";
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    // 禁用缩放
    addMeta() {
      const meta = document.createElement("meta");
      meta.content =
        "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no";
      meta.name = "viewport";
      document.getElementsByTagName("head")[0].appendChild(meta);
    },
    getCode() {
      this.$refs.formRef.validateField("mobile", async (valid) => {
        if (valid === "") {
          // 发送验证码
          this.loading = true;
          await getSmsCode({
            mobile: this.formData.mobile,
          });
          this.loading = false;
          // if (res && res.batchId) {
          // this.batchId = res.batchId;
          let j = 60;
          this.send = true;
          this.sendCodeText = `${j}s后重新发送`;
          // eslint-disable-next-line vars-on-top, no-var
          var i = setInterval(() => {
            // eslint-disable-next-line no-plusplus
            j--;
            if (j === 0) {
              this.send = false;
              this.sendCodeText = "获取验证码";
              clearInterval(i);
            } else {
              this.send = true;
              this.sendCodeText = `${j}s后重新发送`;
            }
          }, 1000);
          // }
        }
      });
    },
    async through() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const params = {
            ...this.formData,
            result: "AGREE",
            uniqueFlag: this.$route.query.uuid,
          };
          try {
            await approveUpdate(params);
            this.$message.success("操作成功");
            this.showResult = true;
            this.approvalResult = "success";
          } catch {
            this.$message.error("操作失败");
          }
        }
      });
    },
    async rejected() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const params = {
            ...this.formData,
            result: "REJECT",
            uniqueFlag: this.$route.query.uuid,
          };
          try {
            await approveUpdate(params);
            this.$message.success("操作成功");
            this.showResult = true;
            this.approvalResult = "fail";
          } catch {
            this.$message.error("操作失败");
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.approval {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background: #ffff;
  .title {
    text-align: center;
    font-size: 18px;
    padding-top: 24px;
  }
  .form-container {
    padding: 24px;
    .label {
      position: relative;
      padding-left: 10px;
      > span:first-child {
        &::before {
          content: "*";
          color: red;
          font-size: 18px;
          display: block;
          height: 100%;
          position: absolute;
          top: 3px;
          left: 0;
          text-align: center;
        }
      }
    }
    .row-phone {
      display: flex;
      align-items: center;
      .getCodeText {
        color: #06b880;
        width: 150px;
        margin-left: 10px;
      }
      .ant-btn[disabled] {
        color: #999;
      }
    }
  }
  .button-group {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }
}

.container {
  width: 100vw;
  height: 100vh;
}

.approval-result {
  width: 100vw;
  height: 100vh;

  div {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  &__success {
    background-image: url("~@/assets/img/smart-wiring/approval-success-web.png");
  }

  &__fail {
    background-image: url("~@/assets/img/smart-wiring/approval-fail-web.png");
  }
}

@media screen and (max-width: 500px) {
  .approval-result {
    width: 100vw;
    height: 100vh;

    div {
      width: 100%;
      height: 100%;
    }

    &__success {
      background-image: url("~@/assets/img/smart-wiring/approval-success-mobile.png");
    }

    &__fail {
      background-image: url("~@/assets/img/smart-wiring/approval-fail-mobile.png");
    }
  }
}
</style>
